import React from 'react';
import SkeletonMUI, { SkeletonProps } from '@material-ui/lab/Skeleton';

export const Skeleton: React.FC<SkeletonProps> = ({ children, ...rest }) => {
	return <SkeletonMUI {...rest} />;
};
